import { createAction, createReducer } from 'redux-act';

import { TYPE_VALUES } from '../constants/search';
import { decorateSearchList } from '../helpers/search';
import { TErrorModel, TSearchTypes } from '../interfaces/news';
import { ISearchItem, ISearchParams } from '../interfaces/search';
import { searchMaterials } from '../services/news';
import { searchQna } from '../services/qna';
import { App } from '../types';

export interface ISearchPayload {
  type: TSearchTypes;
  data: ISearchItem[];
  loadMore?: boolean;
  hasMore?: boolean;
}

export interface ISearchData {
  data: ISearchItem[];
  hasMore: boolean;
}

export interface IState {
  news: ISearchData;
  qna: ISearchData;
  listType: TSearchTypes;
  loading: boolean;
  error: TErrorModel;
}

const initialState: IState = {
  news: {
    data: [],
    hasMore: false,
  },
  qna: {
    data: [],
    hasMore: false,
  },
  listType: null,
  loading: false,
  error: null,
};

export const startLoadingMaterials = createAction('search/loading');
export const loadMaterialsSuccess = createAction<ISearchPayload>('search/success');
export const resetMaterials = createAction<{ type: TSearchTypes }>('search/reset');
export const loadMaterialsFail = createAction<TErrorModel>('search/fail');

export const fetchSearchMaterials = (params: ISearchParams): App.ReduxAction => {
  return async (dispatch) => {
    const { type, query, loadMore } = params;

    let resultType = type;

    const qnaQuery = {
      ...query,
      Page: query.PageIndex,
      Limit: query.PageSize,
    };

    try {
      dispatch(startLoadingMaterials());
      let data = [];

      if (type === TYPE_VALUES.NEWS) {
        data = await searchMaterials(query);

        if (!data?.length) {
          dispatch(resetMaterials({ type: TYPE_VALUES.NEWS }));
          const qnaData = await searchQna(qnaQuery);

          if (qnaData?.length) {
            data = qnaData;
            resultType = TYPE_VALUES.QNA;
          }
        }
      } else {
        data = await searchQna(qnaQuery);
        dispatch(resetMaterials({ type: TYPE_VALUES.QNA }));

        if (!data?.length) {
          const newsData = await searchMaterials(query);
          if (newsData?.length) {
            data = newsData;
            resultType = TYPE_VALUES.NEWS;
          }
        }
      }

      const decoratedData = decorateSearchList(data);
      const hasMore = decoratedData?.length === query.PageSize;

      dispatch(loadMaterialsSuccess({ type: resultType, data: decoratedData, loadMore, hasMore }));
    } catch (error) {
      dispatch(loadMaterialsFail(error));
    }
  };
};

const search = createReducer<IState>({}, initialState)
  .on(startLoadingMaterials, (state) => {
    return {
      ...state,
      loading: true,
    };
  })

  .on(loadMaterialsSuccess, (state, { type, data, loadMore, hasMore }) => {
    return {
      ...state,
      [type]: {
        data: loadMore ? [...state[type].data, ...data] : [...data],
        hasMore,
      },
      listType: type,
      loading: false,
    };
  })

  .on(resetMaterials, (state, { type }) => {
    return {
      ...state,
      [type]: {
        data: [],
        hasMore: false,
      },
      loading: true,
    };
  })

  .on(loadMaterialsFail, (state, error) => {
    return {
      ...state,
      error,
      loading: false,
    };
  });

export default search;
